module.exports = __webpack_public_path__ + "media/images/intro_slide_img_01-5a2f0fd6860e819f3805584ed7e47c06.jpg";